import axios from 'axios';
import React, {useEffect, useState} from 'react';
import { useLocation } from 'react-router-dom';
import emailjs from '@emailjs/browser';


export default function Documento() {
    const location = useLocation();
    const { documentoInfo } = location.state || { documentoInfo: undefined };

    const dadosStorage = sessionStorage.getItem('documento');
    //era localStorage.getItem('documento') mas estava dando problema de atualização do valor, então mudei para sessionStorage que atualiza normalmente
    const documento = JSON.parse(dadosStorage);
    const [origem, setOrigem] = useState('E');
    //const uuid = location.pathname.split('/')[2];
    const tokenAPI = "ae28b7ca-7db9-11ee-aa2d-fa163e6e2f00";
    const [errorMessage, setErrorMessage] = useState('');
    
    const [file, setFile] = useState(null);
    const [PdfFile, setPdfFile] = useState({
        NomePdf: '',
        Arquivo: ''
    });
    const [uploadPDFStatus, setUploadPDFStatus] = useState('');
    const now = new Date();
    const customFormatDate = new Intl.DateTimeFormat('pt-BR', {
    year: 'numeric',
    day: '2-digit',
    month: '2-digit',
    hour: 'numeric',
    minute: 'numeric',
    second: 'numeric',
    hour12: false
    }).format(now).replace(/\//g, '/').replace(',',''); // Replace slashes with hyphens
    
    const customFormatSmallDate = new Intl.DateTimeFormat('pt-BR', {
    year: 'numeric',
    day: '2-digit',
    month: '2-digit'
    }).format(now).replace(/\//g, '/').replace(',',''); // Replace slashes with hyphens
    const uuid = customFormatDate.replace('-', '').replace(' ', '').replace(':', '').replace(':', '').replace('/', '').replace('/', '');    
    const [campos, setCampos] = useState({
        IdDocumento: 0,
        docDescricao: '',
        docTipo: '',
        docCaminho: '',
        docObservacoes: '',
        docMensagem: '',
        docStatus: 1,
        docCriadoPor: sessionStorage.getItem('nomeUsuario'),
        docCriadoEm: customFormatDate,
        docAlteradoPor: sessionStorage.getItem('nomeUsuario'),
        docAlteradoEm: customFormatDate,
        docCodigoGUID: ''
    });

    if (documentoInfo) {
        preencherCampos();
    }

    function preencherCampos() {
        campos.IdDocumento = documentoInfo.IdDocumento;
        campos.docDescricao = documentoInfo.docDescricao;
        campos.docTipo = documentoInfo.docTipo;
        campos.docCaminho = documentoInfo.docCaminho;
        campos.docObservacoes = documentoInfo.docObservacoes;
        campos.docMensagem = documentoInfo.docMensagem;
        campos.docStatus = documentoInfo.docStatus;
        campos.docCriadoPor = documentoInfo.docCriadoPor;
        campos.docCriadoEm = documentoInfo.docCriadoEm;
        campos.docAlteradoPor = sessionStorage.getItem('nomeUsuario');
        campos.docAlteradoEm = customFormatDate;
        campos.docCodigoGUID = documentoInfo.docCodigoGUID;
    }

    function handleInputChange(event) {
        campos[event.target.name] = event.target.value;
        if(documentoInfo) {
            documentoInfo[event.target.name] = event.target.value;
        }
        //console.log(campos);
    };

    var bloqueio = false;
    const handleFileChange = (event) => {
        setFile(event.target.files[0]);
    };

    function handleFecharModal(){
        if(prestacaoInfo !== undefined || prestacaoInfo === false){
            //setOpenModal(false);
            window.history.back();
        }
        else {   
            //window.location.href = '/Associado'; 
            window.history.back();
        }
    };

    function handleFormSubmit(event) {
        event.preventDefault();
        if (campos.docDescricao === '')
        {
            setErrorMessage('Informe a descrição do documento!');
            bloqueio = true;
            return;
        }
        else {
            bloqueio = false;
            setErrorMessage('');
        }

        if (bloqueio === false){
            bloqueio = true;
            if (file) {
                const formData = new FormData();
                formData.append('pdfFile', file);
                var reader = new FileReader();
                reader.readAsDataURL(file);
                reader.onloadend = function(fileLoadedEvent) {
                    var srcData = fileLoadedEvent.target.result
                    PdfFile['Arquivo'] = srcData.split(',')[1];
                    PdfFile['NomePdf'] = uuid+'-'+file.name;
                    setPdfFile(PdfFile)
                }

                axios
                .post(process.env.REACT_APP_API_URL +
                    '/routes.php?metodo=uploadDocumento', formData, {
                        headers: {
                            'X-Access-Token': tokenAPI,
                            'Content-Type': 'multipart/form-data; charset=UTF-8'
                        }
                    }
                )
                .then((response) => {
                    campos.docCaminho = response.data['filePath'];
                    if (documentoInfo) {
                        documentoInfo.docCaminho = response.data['filePath'];
                    }
                    setUploadPDFStatus(`Sucesso: ${response.data.message}`);
                    bloqueio = false;
                    salvarDocumento();
                })
                .catch((error) => {
                    console.error('Houve um erro ao enviar o formulário:', error);
                    setUploadPDFStatus(`Erro o enviar: ${error.message ? error.response.data.message : error.message}`);
                    bloqueio = true;
                    return;
                });
            } else {
                bloqueio = false;
                salvarDocumento();
            }
        }
    }

    function salvarDocumento() {
        if (bloqueio === false)
        {
            if (campos.IdDocumento > 0) {
                axios
                .post(process.env.REACT_APP_API_URL +
                    '/routes.php?metodo=atualizarDocumento', campos, {
                        headers: {
                            'X-Access-Token': tokenAPI,
                            'Content-Type': 'application/json; charset=UTF-8'
                        }
                    }
                )
                .then(response=> {
                    bloqueio = false;
                    alert(response.data['mensagem']);
                    window.location.href = '/#/Documentos'
                })
                .catch(error => {
                    console.error('Houve um erro ao enviar o formulário:', error);
                    bloqueio = false;
                    alert('Houve um erro ao atualizar documento. Por favor, tente novamente.');
                });
            }
            else {
                axios
                .post(process.env.REACT_APP_API_URL +
                    '/routes.php?metodo=novoDocumento', campos, {
                        headers: {
                            'X-Access-Token' : tokenAPI,
                            'Content-Type': 'application/json; charset=UTF-8'
                        }
                    }
                )
                .then(response => {
                    bloqueio = false;
                    alert('Cadastro realizado com sucesso!');
                    window.location.href = '/#/Documentos';
                })
                .catch(error => {
                    console.error('Houve um erro ao enviar o formulário:', error);
                    bloqueio = false;
                    alert('Houve um erro ao cadastrar documento. Por favor, tente novamente.');
                })
            }
        }
    }

    function handleFecharModal(){
        //setOpenModal(false);
        window.history.back();
    }

    // console.log(campos);
    // console.log(documentoInfo);
    
    return (
        <>
            <main>
                <div>
                    {/* fechar */}
                    <div className='d-flex w100 mt1 flex-column text-align-left'>
                        <div className='text-align-left w80 fs16'>
                            <button
                                className="buttonModalPadraoLaranja fs11"
                                onClick={handleFecharModal}
                            >
                                Fechar
                            </button>
                        </div>
                    </div>
                    {/* form */}
                    <form onSubmit={handleFormSubmit}>
                        <div className='headerMain'>
                            <label className='labelTitulo' >DOCUMENTO</label>
                        </div>
                        <div className="d-flex w100 flex-column tdAlignLeft pb4">
                            {/* Descrição */}
                            <div className="d-flex flex-row divForm">
                                <div className="w100">
                                    <div className='text-align-left divForm fs16'>
                                        <label>DESCRIÇÃO</label>
                                    </div>
                                    <div className='text-align-left divForm w100 fs12'>
                                        <input
                                            defaultValue={campos.docDescricao}
                                            onChange={handleInputChange}
                                            className="pt1 pb1 p1 fs12 w100 text-align-left" 
                                            required
                                            name="docDescricao"
                                            id="docDescricao"
                                        />
                                    </div>
                                </div>
                            </div>
                            {/* Tipo */}
                            <div className="d-flex flex-row divForm">
                                <div className="w100">
                                    <div className='text-align-left divForm fs16'>
                                        <label>TIPO</label>
                                    </div>
                                    <div className='text-align-left divForm w100 fs12'>
                                        <select
                                        defaultValue={campos.docTipo}
                                        onChange={handleInputChange}
                                        className="pt1 pb1 fs12 w100 text-align-center" 
                                        required
                                        name="docTipo"
                                        id="docTipo"
                                        >
                                            <option value="RESTRITO">RESTRITO</option>
                                            <option value="GERAL">GERAL</option>
                                        </select>
                                    </div>
                                </div>
                            </div>
                            {/* observações */}
                            <div className="d-flex flex-row divForm">
                                <div className="w100">
                                    <div className='text-align-left divForm fs16'>
                                        <label>OBSERVAÇÕES</label>
                                    </div>
                                    <div className='text-align-left divForm w100 fs1'>
                                        <textarea
                                            defaultValue={campos.docObservacoes}
                                            onChange={handleInputChange}
                                            className="pt1 pb1 p1 fs12 w100 text-align-left" 
                                            required
                                            name="docObservacoes"
                                            id="docObservacoes"
                                        />
                                    </div>
                                </div>
                            </div>
                            {/* mensagem */}
                            <div className="d-flex flex-row divForm">
                                <div className="w100">
                                    <div className='text-align-left divForm fs16'>
                                        <label>MENSAGEM</label>
                                    </div>
                                    <div className='text-align-left divForm w100 fs1'>
                                        <textarea
                                            defaultValue={campos.docMensagem.replace(/<br \/>/g, '\n')}
                                            onChange={handleInputChange}
                                            className="pt1 pb1 p1 fs12 w100 text-align-left" 
                                            required
                                            name="docMensagem"
                                            id="docMensagem"
                                        />
                                    </div>
                                    <div>
                                        {/* Contador de caracteres da mensagem */}

                                        <p>{campos.docMensagem ? campos.docMensagem.length : 0}/1024</p>
                                    </div>
                                </div>
                            </div>
                            {/* status */}
                            <div className="d-flex flex-row divForm">
                                <div className="w100">
                                    <div className='text-align-left divForm fs16'>
                                        <label>ATIVO</label>
                                    </div>
                                    <div className='text-align-left divForm w100 fs12'>
                                        <select
                                            defaultValue={campos.docStatus}
                                            onChange={handleInputChange}
                                            className="pt1 pb1 fs12 w100 text-align-center" 
                                            required
                                            name="docStatus"
                                            id="docStatus"
                                            >
                                                <option value="0">Não</option>
                                                <option value="1">Sim</option>
                                            </select>
                                    </div>
                                </div>
                            </div>
                            {/* Documento */}
                            <div className="d-flex flex-row divForm">
                                <div className="w100">
                                    <div className='text-align-left divForm fs16'>
                                        <label>DOCUMENTO</label>
                                    </div>
                                    <div className='text-align-left divForm w100 fs12'>
                                        <input
                                        type="file"
                                        name="uploaDocumento"
                                        className="p1 bgGray fs12 w100"
                                        id="uploadDocumento"
                                        accept=".csv,.xlsx,.pdf"
                                        onChange={handleFileChange} />
                                    <p>{uploadPDFStatus}</p>
                                    </div>
                                </div>
                            </div>
                            {/* salvar */}
                            {parseInt(sessionStorage.pesAdmin) === 1 ? (
                            <div className='text-align-left mt2 mb4 divForm fs14'>
                                <button 
                                    className='buttonModalPadrao pt1 pb2 w100 fs14'
                                    type="submit">
                                    SALVAR DOCUMENTO
                                </button>
                            </div> ) : ('')}
                        </div>
                    </form>
                </div>
            </main>
        </>
    )
}